import React, { memo, useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getAuthorDetail, getAuthorShowreel, setScroll } from '../../actions/wallpaper';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import { CONTEXT } from '../../config';
import wpAuthorDefault from '../../static/wp_author_default.png';
import { getQueryString } from '../../utils/utils';
import Blank from './Blank';
import styles from './WallPaperAuthorDetail.module.less';

const selectWpAuthorShowreel = createSelector(
  state => {
    return state.wallpaper && state.wallpaper;
  },
  info => info.wpAuthorShowreel,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectScroll = createSelector(
  state => state.wallpaper && state.wallpaper,
  info => {
    return info.scroll;
  },
);
export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { action } = useHistory();
  const authorShowreel = useSelector(selectWpAuthorShowreel);
  const logInfoData = useSelector(selectLogInfo);

  const [collectNum, setCollectNum] = useState(null);
  // const [contentElement, setContentElement] = useState(null);
  const [authorInfo, setAuthorInfo] = useState({});
  const authorId = getQueryString('authorId');
  const scrollInfo = useSelector(selectScroll);
  // const scrollElHeight = useSelector(selectScrollElHeight);
  const [contentElHeight, setContentElHeight] = useState(0);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Wallpaper_AuthorWorks`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            authorId,
          },
        }),
      );
    };
  }, []);

  /**
   * PUSH 滚动到最顶端
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (action === 'PUSH') {
      el.scrollTo(0, 0);
    }
  }, []);
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (el.scropTop > 0 && action === 'POP') {
      dispatch(
        setScroll({
          authorScrollTop: 0,
        }),
      );
    }
  }, [authorShowreel]);
  /**
   * POP 滚动到之前位置
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (contentElHeight && scrollInfo && scrollInfo.authorScrollTop && action === 'POP') {
      if (contentElHeight <= scrollInfo.authorScrollTop) {
        el.scrollTo(0, scrollInfo.authorScrollTop - 20);
      } else {
        el.scrollTo(0, scrollInfo.authorScrollTop);
      }
    }
  }, [contentElHeight]);

  useEffect(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_AuthorWorks',
        label: '',
        param2: {
          source: `Wallpaper_AuthorWorks`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_AuthorWorks`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  // useEffect(() => {
  //   setContentElement(document.getElementById('container_content'));
  // }, [document.getElementById('container_content')]);

  useEffect(() => {
    if (authorInfo.collectCount >= 10000) {
      // 初始化心
      setCollectNum(`${Math.round((authorInfo.collectCount / 10000) * 10) / 10}万`);
    } else {
      setCollectNum(authorInfo.collectCount);
    }
  }, [authorInfo]);

  /**
   * 一进来获取作者信息
   */
  useEffect(() => {
    dispatch(
      getAuthorDetail({
        params: { authorId, refresh: true },
        callback: res => {
          setAuthorInfo(res);
        },
      }),
    );
  }, []);

  /**
   * 获取作者图片
   */
  useEffect(() => {
    if (
      action !== 'POP' ||
      authorShowreel.list.length === 0 ||
      (authorShowreel &&
        authorShowreel.pagenation &&
        authorShowreel.pagenation.authorId &&
        authorId !== authorShowreel.pagenation.authorId)
    ) {
      dispatch(
        getAuthorShowreel({
          ...authorShowreel.pagenation,
          authorId,
          skip: 0,
          refresh: true,
        }),
      );
    }
  }, []);

  const onMouseEnter = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Author_QrCode',
        label: '',
        param2: {
          source: `Wallpaper_AuthorWorks`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId,
        },
      }),
    );
  }, []);

  const handleShowMoreAuthor = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Author_More',
        label: '',
        param2: {
          source: `Wallpaper_AuthorWorks`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId,
        },
      }),
    );
    history.push(`${CONTEXT}/wpauthorlist`);
  });

  const loadMore = useCallback(() => {
    if (!authorShowreel.load) {
      if (authorShowreel.pagenation.count >= authorShowreel.list.length) {
        dispatch(
          getAuthorShowreel({
            ...authorShowreel.pagenation,
            authorId,
            skip: authorShowreel.list.length,
          }),
        );
      }
    }
  });

  const getClassType = useCallback((index = 0) => {
    const pos = index % 8;
    if (pos > 2 && pos < 5) {
      if (pos === 3) {
        return 'big_space';
      }
      return 'big';
    }
    if (pos === 1 || pos === 6) {
      return 'small_center';
    }
    return 'small';
  });
  const handleSaveScrollTop = () => {
    const el = document.getElementById('container_content');
    dispatch(
      setScroll({
        authorScrollTop: el && el.scrollTop,
      }),
    );
  };

  const handleMeasureHeight = useCallback(node => {
    if (node) {
      setContentElHeight(node.clientHeight);
    }
  });

  return (
    <div onClick={handleSaveScrollTop} ref={handleMeasureHeight}>
      {authorInfo && authorInfo.authorName && (
        <div className={styles.author}>
          <div className={styles.head}>
            <img
              src={(authorInfo && authorInfo.headPortrait) || wpAuthorDefault}
              alt=""
              className={styles.head}
            />
          </div>
          <div className={styles.desc}>
            <div className={styles.block}>
              <div className={styles.name} title={authorInfo && authorInfo.authorName}>
                {authorInfo && authorInfo.authorName}
              </div>

              <div className={styles.worksNum}>
                {(authorInfo && authorInfo.wallpaperCount) || 0}&nbsp;作品
              </div>
              {collectNum && authorInfo && authorInfo.collectCount && (
                <>
                  <div className={styles.divider} />
                  <div className={styles.worksCollect}>{collectNum}&nbsp;收藏</div>
                </>
              )}
              {authorInfo && authorInfo.qrCode && (
                <>
                  <div className={styles.divider} />
                  <div className={styles.worksPick} onMouseEnter={onMouseEnter}>
                    <i className="iconfont icon-qrcode" style={{ fontSize: '13px' }} />
                    &nbsp;关注
                    <div className={styles.qrCode}>
                      <img
                        src={authorInfo && authorInfo.qrCode}
                        alt=""
                        className={styles.qrCodeImg}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className={styles.worksDesc} title={authorInfo && authorInfo.authorDesc}>
              {authorInfo && authorInfo.authorDesc}
            </div>
          </div>
          <div className={styles.authorMore} onClick={handleShowMoreAuthor}>
            更多作者
          </div>
        </div>
      )}
      <div className={styles.works}>
        {authorShowreel.pagenation.count < 1 && <Blank load={authorShowreel.load} />}
        {authorId === authorShowreel.pagenation.authorId && (
          <InfiniteScroll
            pageStart={1}
            loadMore={loadMore}
            hasMore={authorShowreel.list.length < authorShowreel.pagenation.count}
            loader={
              <div className="loader" key={0}>
                ----------加载中----------
              </div>
            }
            initialLoad={false}
            useWindow={false}
            getScrollParent={() => document.getElementById('container_content')}
          >
            <div className={styles.showreel}>
              {authorShowreel.list.map((item, index) => {
                return (
                  <WallpaperCard
                    wallpaper={item}
                    key={index}
                    cardInfo={{
                      pageSource: 'authorDetail',
                      pageTage: '',
                      authorId,
                      classType: getClassType(index),
                      isCollect: true,
                      isWallpaper: true,
                      isDeleteColl: false,
                      isDeleteUsed: false,
                      isPreview: true,
                    }}
                    logInfo={{ source: 'Wallpaper_AuthorWorks' }}
                  />
                );
              })}
              {authorShowreel.list.length >= authorShowreel.pagenation.count &&
                authorShowreel.pagenation.count > 5 && (
                  <div className="loader" style={{ width: '800px', paddingBottom: '20px' }}>
                    ----------到底啦----------
                  </div>
                )}
            </div>
          </InfiniteScroll>
        )}
        <ScrollTop />
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          background: '#fff',
          height: '25px',
          zIndex: '1001',
          width: '830px',
          left: '200px',
        }}
      />
    </div>
  );
});
